export default __webpack_public_path__ + "static/media/BCH.88117821.png";